/** 业务默认参数 —— 与 backend config/constants.py 保持一致 */

export const DEFAULT_PENALTY_BASE = 300;
export const DEFAULT_EFF = 0.82;
export const DEFAULT_CURT_THRES = 1.0;
